import { forwardRef } from 'react';

import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material/Checkbox';
import CheckboxIcon from 'shared/icons/Check';
import MinusIcon from 'shared/icons/Minus';

import { CheckboxIconWrapper } from './Checkbox.style';

type CheckboxProps = MuiCheckboxProps;

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  return (
    <MuiCheckbox
      sx={{ padding: 0 }}
      ref={ref}
      icon={<CheckboxIconWrapper />}
      indeterminateIcon={
        <CheckboxIconWrapper checked>
          <MinusIcon sx={{ fontSize: '1.2rem', color: '#fff' }} />
        </CheckboxIconWrapper>
      }
      checkedIcon={
        <CheckboxIconWrapper checked>
          <CheckboxIcon sx={{ fontSize: '1.2rem', color: '#fff' }} />
        </CheckboxIconWrapper>
      }
      {...props}
    />
  );
});

export default Checkbox;
